<div class="zx-otp-code" dir="ltr" [class.zx-otp-code-error]="showError" [class.zx-otp-code-disabled]="disabled"
    [class.zx-otp-code-dark]="isDarkMode" (click)="focus()">
    <div *ngFor="let digit of slots; let i = index" class="zx-otp-slot" [class.zx-otp-slot-filled]="digit"
        [class.zx-otp-slot-active]="(isFocused || showError) && !disabled && i === activeIndex">
        {{ digit }}
    </div>
    <input #codeInput class="zx-otp-input" type="text" name="otp-code" inputmode="numeric" pattern="[0-9]*"
        autocomplete="one-time-code" maxlength="6" [disabled]="disabled"
        [attr.aria-label]="'log-in-dialog-code-title' | translate" (input)="onInput(codeInput.value)"
        (focus)="isFocused = true" (blur)="isFocused = false">
</div>
